var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.switchLayout(),{tag:"component"}),(_vm.getLoading)?_c('loading'):_vm._e(),_c('ModalIdle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }